import { render, staticRenderFns } from "./NcpPasswordResetPage.vue?vue&type=template&id=4a6e0df6"
import script from "./NcpPasswordResetPage.vue?vue&type=script&lang=js"
export * from "./NcpPasswordResetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports